var render = function render(_c,_vm){return _c('svg',{staticClass:"icon-breadcrumb",class:_vm.props.direction,attrs:{"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.41 -6.16331e-08L-2.47757e-07 1.33198L6 7L12 1.33198L10.59 -4.62904e-07L6 4.32659L1.41 -6.16331e-08Z","fill":"#7F7F7F"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }